import "./AccountPage.css";
import { useEffect, useState } from "react";
import SideBar from "../../SideBar";
import { BACKEND_LINK } from "../../App";
import { useNavigate } from "react-router-dom";

function AccountPage({ logout }) {
	const [isDeleteOpen, setIsDeleteOpen] = useState(false);
	const [isPasswordOpen, setIsPasswordOpen] = useState(false);
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [currentPassword, setCurrentPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [deleteError, setDeleteError] = useState("");
	const [changeError, setChangeError] = useState("");
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const navigate = useNavigate();
    const fetchAllUserInfo = async () => {
        fetch(`${BACKEND_LINK}/me`, {
            method: "GET",
            credentials: "include",
          }).then(response => {
            if(!response.ok) {
              setUsername("There was an error when communicating with the server.");
              setEmail("There was an error when communicating with the server.");
              return;
            }
            return response.json();
          }).then(data => {
            setUsername(data.username);
            setEmail(data.email);
          }).catch(error => console.error(error));
    };
    useEffect(() => {fetchAllUserInfo();}, [])

	const deleteUser = () => {
		fetch(`${BACKEND_LINK}/auth/delete`, {
            method: "DELETE",
            credentials: "include",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ login: "", password: password })
          }).then(response => {
            if(!response.ok) {
				setDeleteError("Incorrect password.");
            	return;
            }
			setDeleteError("");
			navigate("/");
			logout();
          }).catch(error => console.error(error));
	};

	const changePassword = () => {
		fetch(`${BACKEND_LINK}/auth/change`, {
			method: "POST",
            credentials: "include",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ oldPassword: currentPassword, newPassword: newPassword })
          }).then(response => {
            if(response.status == 401) {
				setChangeError("Incorrect password.");
            	return;
            } else if(response.status == 400) {
				setChangeError("New password is too weak.");
            	return;
            }
			setChangeError("");
			setCurrentPassword("");
			setNewPassword("");
			setIsPasswordOpen(false);
          }).catch(error => console.error(error));
	}

    // TODO: YOU MUST MAKE SURE TO REQUEST CURRENT PASSWORD WHEN DELETING ACCOUNT OR CHANGING THE PASSWORD


	return (
		<div className="main account-page">
			<SideBar loggedIn={username != null} isOpen={sidebarOpen} onToggle={setSidebarOpen}></SideBar>
			<button className="menu-toggle" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label="Toggle menu">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
				</svg>
			</button>
			<div className="account-page__content">
				<h1 className="account-page__title">Account</h1>
				<div className="account-page__info">
					<div className="account-page__row">
						<span className="account-page__label">Email</span>
						<span className="account-page__value">{email}</span>
					</div>
					<div className="account-page__row">
						<span className="account-page__label">Username</span>
						<span className="account-page__value">{username ?? "Not logged in"}</span>
					</div>
				</div>

				<div className="account-page__actions">
					<button
						className="account-page__button"
						type="button"
						onClick={() => {
							setIsPasswordOpen(true);
							setChangeError("");
						}}
					>
						Change password
					</button>
					<button className="account-page__button" type="button" onClick={() => {logout(); navigate("/")}}>
						Logout
					</button>
					<button
						className="account-page__button account-page__button--danger"
						type="button"
						onClick={() => {
							setIsDeleteOpen(true);
							setDeleteError("");
						}}
					>
						Delete account
					</button>
				</div>
			</div>
			{isPasswordOpen ? (
				<div className="account-page__modal-backdrop" onClick={() => setIsPasswordOpen(false)}>
					<div className="account-page__modal" onClick={(event) => event.stopPropagation()}>
						<h3 className="account-page__modal-title">Change password</h3>
						<p className="account-page__modal-text">
							Enter your current password and a new password.
						</p>
						<div className="account-page__row">
							<label className="account-page__label" htmlFor="change-password-current">
								Current password
							</label>
							<input
								id="change-password-current"
								className="account-page__input"
								type="password"
								value={currentPassword}
								onChange={(event) => {
									setCurrentPassword(event.target.value);
									if (changeError) {
										setChangeError("");
									}
								}}
								placeholder="Enter your current password"
								autoComplete="current-password"
							/>
						</div>
						<div className="account-page__row">
							<label className="account-page__label" htmlFor="change-password-new">
								New password
							</label>
							<input
								id="change-password-new"
								className="account-page__input"
								type="password"
								value={newPassword}
								onChange={(event) => {
									setNewPassword(event.target.value);
									if (changeError) {
										setChangeError("");
									}
								}}
								placeholder="Enter a new password"
								autoComplete="new-password"
							/>
						</div>
						{changeError ? (
							<p className="account-page__modal-text">{changeError}</p>
						) : null}
						<div className="account-page__modal-actions">
							<button className="account-page__button" type="button" onClick={() => setIsPasswordOpen(false)}>
								Cancel
							</button>
							<button className="account-page__button" type="button" onClick={() => changePassword()}>
								Change
							</button>
						</div>
					</div>
				</div>
			) : null}
			{isDeleteOpen ? (
				<div className="account-page__modal-backdrop" onClick={() => setIsDeleteOpen(false)}>
					<div className="account-page__modal" onClick={(event) => event.stopPropagation()}>
						<h3 className="account-page__modal-title">Delete account?</h3>
						<p className="account-page__modal-text">
							Are you sure you want to delete the account? This action cannot be undone.
						</p>
						<div className="account-page__row">
							<label className="account-page__label" htmlFor="delete-account-password">
								Password
							</label>
							<input
								id="delete-account-password"
								className="account-page__input"
								type="password"
								value={password}
								onChange={(event) => {
									setPassword(event.target.value);
									if (deleteError) {
										setDeleteError("");
									}
								}}
								placeholder="Enter your password"
								autoComplete="current-password"
							/>
						</div>
						{deleteError ? (
							<p className="account-page__modal-text">{deleteError}</p>
						) : null}
						<div className="account-page__modal-actions">
							<button className="account-page__button" type="button" onClick={() => setIsDeleteOpen(false)}>
								Cancel
							</button>
							<button className="account-page__button account-page__button--danger" type="button"
							onClick={() => deleteUser()}>
								Delete
							</button>
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
}

export default AccountPage;
